// assets/shopify-forms-align.js
document.addEventListener('DOMContentLoaded', () => {
  const applyFormsLabelAlign = () => {
    document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
      if (!embed.shadowRoot) return;

      // prevent duplicate injection
      if (embed.shadowRoot.querySelector('style[data-forms-align]')) return;

      const style = document.createElement('style');
      style.setAttribute('data-forms-align', '');
      style.textContent = `
        /* labels RTL – keep them on the right, both normal + floating state */
        label {
          text-align: right !important;
          width: 100% !important;
          /* force the floating label to stay on the right side */
          left: auto !important;
          right: 0.75rem !important;  /* tweak this value if you want more/less padding */
          transform-origin: top right !important;
        }

        /* inputs RTL typing */
        input,
        textarea {
          direction: rtl !important;
          text-align: right !important;
        }
      `;
      embed.shadowRoot.appendChild(style);
    });
  };

  applyFormsLabelAlign();

  // survive re-renders / async loads
  new MutationObserver(applyFormsLabelAlign)
    .observe(document.body, { childList: true, subtree: true });
});
